export const ROSTER_NAME_COLUMN_ID = "name";
// The column carries the person, not just their name: the ServiceTitan ID sits
// under it as a subline rather than taking a column of its own.
export const ROSTER_NAME_COLUMN_LABEL = "Tech";
